import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const MarkupRulesContext = createContext(initState)

export const MarkupRulesProvider = createProvider(MarkupRulesContext, initState)
